import { render, staticRenderFns } from "./CampaignSendingStats.vue?vue&type=template&id=8f8e7ec0&"
import script from "./CampaignSendingStats.vue?vue&type=script&lang=js&"
export * from "./CampaignSendingStats.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSendingStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports